var map = {
	"./da": 82342,
	"./da.js": 82342,
	"./de": 55770,
	"./de.js": 55770,
	"./en": 17342,
	"./en.js": 17342,
	"./fr": 77761,
	"./fr.js": 77761,
	"./nl": 99947,
	"./nl.js": 99947
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95653;